"use client";

import clsx from "clsx";
import Image from "next/image";
import { forwardRef, type ButtonHTMLAttributes } from "react";
import { GAIL_ASSISTANT_PANEL_TIMING } from "@/utils/chat/gailGptLauncher";
import styles from "./GailGptLauncher.module.css";

type GailAssistantLauncherButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> & {
  /** The button's accessible name. */
  label: string;
  /** Draws attention while the first-visit tip points at the button. */
  highlighted?: boolean;
  placement?: "corner" | "topbar";
};

const GailAssistantLauncherButton = forwardRef<HTMLButtonElement, GailAssistantLauncherButtonProps>(
  function GailAssistantLauncherButton(
    { label, highlighted = false, placement = "corner", className, style, ...props },
    ref
  ) {
    const timing = { transitionTimingFunction: GAIL_ASSISTANT_PANEL_TIMING };
    return (
      <button
        {...props}
        ref={ref}
        type="button"
        aria-label={label}
        data-highlighted={highlighted}
        data-labeled="true"
        data-placement={placement}
        className={clsx(
          "flex shrink-0 items-center justify-center border-transparent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-button_primary",
          placement === "topbar"
            ? "h-[38px] gap-2 rounded-[10px] border-[1.5px] pl-1.5 pr-3.5 text-900"
            : "h-12 gap-2.5 rounded-xl border-[1.5px] px-3.5 text-900",
          styles.launcher,
          className
        )}
        style={{ ...timing, ...style }}
      >
        <span className={placement === "topbar" ? "flex h-7 w-7 shrink-0 items-center justify-center" : "contents"}>
          <Image src="/icons/gail2-icon-blue.svg" alt="" width={placement === "topbar" ? 20 : 22} height={placement === "topbar" ? 20 : 22} className="shrink-0" />
        </span>
        <span className="whitespace-nowrap text-sm font-medium">{label}</span>
      </button>
    );
  }
);

export default GailAssistantLauncherButton;
